var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDriverIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 18C5.25 18.41 5.59 18.75 6 18.75C6.41 18.75 6.75 18.41 6.75 18V16C6.75 15.59 6.41 15.25 6 15.25C5.59 15.25 5.25 15.59 5.25 16V18Z",
    fill: "#14477D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.75C9.59 18.75 9.25 18.41 9.25 18V16C9.25 15.59 9.59 15.25 10 15.25C10.41 15.25 10.75 15.59 10.75 16V18C10.75 18.41 10.41 18.75 10 18.75Z",
    fill: "#14477D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 17.75H14C13.59 17.75 13.25 17.41 13.25 17C13.25 16.59 13.59 16.25 14 16.25H18C18.41 16.25 18.75 16.59 18.75 17C18.75 17.41 18.41 17.75 18 17.75Z",
    fill: "#14477D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 8.25C5.25 8.66 5.59 9 6 9C6.41 9 6.75 8.66 6.75 8.25V6.25C6.75 5.84 6.41 5.5 6 5.5C5.59 5.5 5.25 5.84 5.25 6.25V8.25Z",
    fill: "#14477D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25 8.25C9.25 8.66 9.59 9 10 9C10.41 9 10.75 8.66 10.75 8.25V6.25C10.75 5.84 10.41 5.5 10 5.5C9.59 5.5 9.25 5.84 9.25 6.25V8.25Z",
    fill: "#14477D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14 8H18C18.41 8 18.75 7.66 18.75 7.25C18.75 6.84 18.41 6.5 18 6.5H14C13.59 6.5 13.25 6.84 13.25 7.25C13.25 7.66 13.59 8 14 8Z",
    fill: "#14477D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM21.25 12.75V15C21.25 19.61 19.61 21.25 15 21.25H9C4.39 21.25 2.75 19.61 2.75 15V12.75H21.25ZM21.25 11.25H2.75V9C2.75 4.39 4.39 2.75 9 2.75H15C19.61 2.75 21.25 4.39 21.25 9V11.25Z",
    fill: "#14477D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverIcon);
export default __webpack_public_path__ + "static/media/DriverIcon.4671b0ed434a33daaa37ce0f14ac6abb.svg";
export { ForwardRef as ReactComponent };